import { Navigate, Outlet, useParams } from 'react-router-dom'

import NoScansAvailable from '@routes/ScanSelection/NoScansAvailable'
import ScanDoesNotExist from '@routes/ScanSelection/ScanDoesNotExist'
import { useScansOfCurrentStore } from '@state/scans.ts'
import { useViewSettings } from '@state/viewSettings'

import GuardLoadingScreen from './GuardLoadingScreen'

function ScanSelectGuard() {
  const { scanId: selectedScanId } = useParams<{ scanId?: string }>()
  const { data: scans = [], isLoading } = useScansOfCurrentStore()
  const { isLoading: areSettingsLoading } = useViewSettings()

  if (isLoading || areSettingsLoading) {
    return <GuardLoadingScreen />
  }

  if (scans.length === 0) {
    return <NoScansAvailable />
  }

  // redirect to latest scan if no scan is selected
  if (!selectedScanId) {
    return <Navigate to='latest' replace />
  }

  const scanIds = scans.map(scan => scan.id)

  // if a scan was selected, but it does not exist, show error
  if (selectedScanId !== 'latest' && !scanIds.includes(selectedScanId)) {
    return <ScanDoesNotExist />
  }

  return <Outlet/>
}

export default ScanSelectGuard
